import React from "react";

export const ErrorLabel = ({ errorMessage, highlightOnly = false, children }) => {
    const errorClass = errorMessage || highlightOnly ? "-error" : "";

    return (
        <div className={`validation-wrapper ${errorClass}`}>
            {children}
            {errorMessage && !highlightOnly && <div className="error-message">{errorMessage}</div>}
        </div>
    );
};
